import React from "react";
import { PlayerState } from "../../../../core/protocol/types";
import { TEAM_NAMES, TEAM_COLORS } from "../../../../core/constants";
import "../../ResultScreen.css";

interface TeamStats {
  frags: number;
  deaths: number;
  score: number;
  lines: number;
  players: number;
  roundWins?: number;
}

interface SpeedTableProps {
  playersByTeam: Map<number, PlayerState[]>;
  activeTeams: Array<[number, TeamStats]>;
  localConnectionId: string | null;
  localNumPlayer?: number;
  localTeam: number;
  isSinglePlayer: boolean;
  gameStats?: Record<string, { getValue: () => number }>;
}

const SpeedTable: React.FC<SpeedTableProps> = ({
  playersByTeam,
  activeTeams,
  localConnectionId,
  localNumPlayer,
  localTeam,
  isSinglePlayer,
  gameStats,
}) => {
  const formatStat = (value: number): string => {
    return value.toLocaleString();
  };

  return (
    <div className="result-screen-table-container">
      <table className="result-screen-table">
        <thead>
          <tr>
            <th className="result-col-player">Player</th>
            <th className="result-col-stat">PPM</th>
            <th className="result-col-stat">BPM</th>
          </tr>
        </thead>
        <tbody>
          {activeTeams.map(([teamId, teamStatsData]) => {
            const teamPlayers = playersByTeam.get(teamId) || [];
            const teamColor = TEAM_COLORS[teamId];
            const isMyTeam = localTeam === teamId;

            return (
              <React.Fragment key={teamId}>
                {teamPlayers.map((player) => {
                  // Use numPlayer for consistency with game logic (matches original design)
                  const isLocalPlayer = localNumPlayer !== undefined && player.numPlayer === localNumPlayer;
                  // Get PPM and BPM from stats
                  let ppm = 0;
                  let bpm = 0;
                  if (isSinglePlayer && gameStats) {
                    // Single player: get from game.stats
                    ppm = gameStats["PPM"]?.getValue() || 0;
                    bpm = gameStats["BPM"]?.getValue() || 0;
                  } else {
                    // Multiplayer: get from player state (synced from server)
                    ppm = typeof player.ppm === "number" ? player.ppm : 0;
                    bpm = typeof player.bpm === "number" ? player.bpm : 0;
                  }

                  return (
                    <tr
                      key={player.connectionId}
                      className={`result-screen-row ${isLocalPlayer ? "local-player" : ""} ${isMyTeam ? "my-team" : ""}`}
                    >
                      <td className="result-col-player">
                        <span style={{ color: teamColor }}>
                          {player.name}
                        </span>
                      </td>
                      <td className="result-col-stat">
                        {formatStat(ppm)}
                      </td>
                      <td className="result-col-stat">
                        {formatStat(bpm)}
                      </td>
                    </tr>
                  );
                })}
                {teamStatsData.players > 1 && (
                  <tr className="result-screen-team-total">
                    <td className="result-col-player">
                      <span style={{ color: teamColor, fontWeight: "bold" }}>
                        {TEAM_NAMES[teamId]} Total
                      </span>
                    </td>
                    <td className="result-col-stat">-</td>
                    <td className="result-col-stat">-</td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SpeedTable;

